var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1493 5.82332C16.2464 5.72621 16.4046 5.72621 16.5017 5.82332L18.1777 7.49932C18.2748 7.59641 18.2748 7.7545 18.1777 7.85161L18.1777 7.85166L16.84 9.18904L14.8118 7.16083L16.1493 5.82332ZM13.2562 6.59513C13.2437 6.60605 13.2316 6.61745 13.2197 6.62934C13.2078 6.64122 13.1964 6.65341 13.1855 6.66587L4.76409 15.0872L4.7633 15.088C4.4335 15.4165 4.25 15.8619 4.25 16.325V19C4.25 19.4142 4.58579 19.75 5 19.75H7.675C8.13818 19.75 8.58359 19.5665 8.91206 19.2366L8.91274 19.2359L17.3655 10.7847C17.3671 10.7832 17.3687 10.7816 17.3703 10.78C17.3719 10.7784 17.3734 10.7769 17.375 10.7753L19.2383 8.91237L19.2383 8.91232C19.9212 8.22943 19.9212 7.12155 19.2383 6.43866L17.5623 4.76266C16.8794 4.07976 15.7716 4.07976 15.0887 4.76266L13.2562 6.59513ZM15.7793 10.2496L7.85072 18.1766L7.84926 18.1781C7.8038 18.2238 7.7415 18.25 7.675 18.25H5.75V16.325C5.75 16.2585 5.77621 16.1962 5.82191 16.1507L5.82333 16.1493L13.7512 8.22149L15.7793 10.2496Z",
    fill: "#50514A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.23294f37891080d579c2f79fa3c59274.svg";
export { ForwardRef as ReactComponent };